import React, { useState, useEffect, memo, useRef } from 'react'
import ReactDOM from 'react-dom'
import * as d3 from 'd3'
import moment from 'moment'
import { Col, Row } from 'antd'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
import '../../css/graph.scss'
import _ from 'lodash'
const Graph = (props) => {
  console.log('props.identifier  ---->>', props.identifier)

  var margin = { top: 10, right: 5, bottom: 80, left: 35 },
    width = props.width || 480 - margin.left - margin.right,
    height = props.height || 370 - margin.top - margin.bottom

  // append the svg object to the body of the page
  var svg

  const [minp, setMinp] = useState(0 + props.data.data[0].values.length - 6) //Last page
  const [maxp, setMaxp] = useState(7 + props.data.data[0].values.length - 6)

  useEffect(() => {
    console.log(svg)
    if (
      d3
        .select('#' + props.identifier)
        .selectAll('svg')
        .empty()
    ) {
      svg = d3
        .select('#' + props.identifier)
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
    } else {
      svg = d3.select('#' + props.identifier).select('svg')
    }

    svg.selectAll('g > *').remove()
    svg.selectAll('path').remove()

    svg = svg
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
    chart(props.data)
  }, [minp, maxp, props.data])

  const [option, setOption] = useState(false)

  const next = () => {
    if (props.data.data[0].values.length > maxp) {
      //d3.select("#"+ props.identifier).remove();
      //document.getElementById( props.identifier).innerHTML = "";
      setMaxp(maxp + 6)
      setMinp(minp + 6)
    }
  }

  const back = () => {
    if (minp - 1 >= 0) {
      //d3.select("#"+ props.identifier + ' > svg').remove()
      //document.getElementById( props.identifier).innerHTML = "";
      setMaxp(maxp - 6)
      setMinp(minp - 6)
    }
  }

  function makeXGridlines(x) {
    return d3.axisBottom(x).ticks(10)
  }

  function makeYGridlines(y) {
    return d3.axisLeft(y).ticks(10)
  }

  const formatDate = (data) => {
    if (!data) return
    //const year=moment().year();
    const arr = data.split(' ')
    const combinedDate = moment(arr[0])
    const formattedDate = moment(combinedDate)
    return formattedDate.format('MM/DD/YYYY')
  }

  function chart(dataReady) {
    var k = dataReady.data.map((d) => {
      return {
        ...d,
        values: d.values.filter(
          (t, i) => t.y != null && t.y.length != 0 && i >= minp && i < maxp
        ),
      }
    })

    var formattedData = k.map((d) => {
      var isRed = false
      return {
        ...d,
        values: d.values.map((i) => {
          var l = 0

          // var valuey = (i.y.reduce((a,c)=>a+c, l))/i.y.length    // Showing  Average of steps
          // console.log(i.y,"i.y",valuey)
          var valuey = !_.isEmpty(i.y) && i.y[0] ? i.y[i.y.length - 1] : 0 // Showing first  value of steps

          if (i.y > d.threshold.max || i.y < d.threshold.min) isRed = true
          return { x: i.x, y: valuey, z: i.y }
        }),
        isRed: isRed,
      }
    })

    console.log(formattedData)
    var xAxisData = dataReady.data[0].values
      .filter((d, i) => {
        return i >= minp && i < maxp
      })
      .map(function (d) {
        return d.x
      }) //

    var allLines = dataReady.data.map((i) => i.reading)
    console.log(xAxisData)
    // A color scale: one color for each group

    var myColor = d3
      .scaleOrdinal()
      .domain(
        dataReady.data.map((i) => {
          return i.reading
        })
      )
      .range(d3.schemeSet2)

    // Add X axis --> it is a date format
    var x = d3.scalePoint().domain(xAxisData).range([0, width]).padding(0.4)
    svg
      .append('g')
      .attr('transform', 'translate(10,' + height + ')')
      .call(d3.axisBottom(x))
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', 'rotate(-45)')
      .style('font-size', '10px')

    // Add Y axis
    var y = d3
      .scaleLinear()
      .domain([
        dataReady.yAxisRange.min > 10
          ? dataReady.yAxisRange.min - 10
          : dataReady.yAxisRange.min,
        dataReady.yAxisRange.max,
      ])
      .range([height, 0])
    svg.append('g').call(d3.axisLeft(y))

    svg
      .append('text')
      .attr('class', 'y label')
      .attr('text-anchor', 'end')
      .attr('y', props.isrotate ? height / 2 : height / 2)
      .attr('x', props.isrotate ? 20 : 20)
      .attr('dy', '.75em')
      .text(props.data.yAxisLable)

    svg
      .append('text')
      .attr('class', 'y label')
      .attr('text-anchor', 'end')
      .attr('y', props.isrotate ? height + 40 : height - 25)
      .attr('x', props.isrotate ? width / 2 : height - 20)
      .attr('dy', '1em')
      .text(props.data.xAxisLable)

    // Add the lines
    var line = d3
      .line()
      .x(function (d) {
        return x(d.x)
      })
      .y(function (d) {
        return y(d.y)
      })

    svg
      .selectAll('myLines')
      .data(formattedData)
      .enter()
      .append('path')
      .attr('transform', 'translate(10,0)')
      .attr('d', function (d) {
        console.log('first==:', dataReady)
        return line(d.values)
      })
      .attr('stroke', function (d) {
        return myColor(d.reading)
      })
      .style('stroke-width', 2)
      .style('fill', 'none')

    var tooltip = d3
      .select('#' + props.identifier)
      .append('div')
      .attr('class', 'chartToolTip')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('visibility', 'hidden')
    // .text("a simple tooltip");

    // Add the points
    svg
      // First we need to enter in a group
      .selectAll('myDots')
      .data(formattedData)
      .enter()
      .append('g')
      .attr('transform', 'translate(10,0)')
      .style('fill', function (d) {
        return myColor(d.reading)
      })
      // Second we need to enter in the 'values' part of this group11
      .selectAll('myPoints')
      .data(function (d) {
        return d.values
      })
      .enter()
      .append('circle')
      .attr('cx', function (d) {
        return x(d.x)
      })
      .attr('cy', function (d) {
        console.log('kilo', d)
        return y(d.y)
      })
      .attr('r', 5)
      .attr('stroke', 'white')
      .on('mouseover', function (d, i) {
        var values = d.z.reduce((a, c) => a + c + ',', '')
        tooltip.html(`<b>Values</b>:${values}`)
        var left = 50
        tooltip
          .style('visibility', 'visible')
          .style('top', d3.select(this).attr('cy') - 32 + 'px')
          .style('left', d3.select(this).attr('cx') - 30 + 'px')
      })
      .on('mouseout', (event) => tooltip.style('visibility', 'hidden'))

    /*svg.append("g")
    .attr("class", "grid")
    .attr("transform", "translate(10," + height + ")")
    .style("shape-rendering","crispEdges")
    .call(makeXGridlines(x)
      .tickSize(-height)
      .tickFormat("")
    );*/

    // Add Y gridlines
    svg
      .append('g')
      .attr('class', 'grid')
      .call(makeYGridlines(y).tickSize(-width).tickFormat(''))

    // Add labels
    svg
      .selectAll('myLable')
      .data(dataReady.data)
      .enter()
      .append('text')
      .attr('x', width - 100)
      .attr('y', function (d) {
        console.log('reading', d)
        return y(d.threshold.min)
      })
      .style('font-size', '12px')
      .style('font-weight', 'bold')
      .attr('transform', 'translate(-10, -5)')
      .text(function (d) {
        return d.reading + ' min'
      })
      .attr('fill', 'black')

    // Diast High
    svg
      .selectAll('myLines')
      .data(dataReady.data)
      .enter()
      .append('line')
      .attr('x1', 0)
      .attr('y1', function (d) {
        console.log('reading', d)
        return y(d.threshold.min)
      })
      .attr('x2', width)
      .attr('y2', function (d) {
        console.log('reading', d)
        return y(d.threshold.min)
      })
      .attr('stroke', 'black')
      .attr('stroke-width', 1)
      .attr('stroke-dasharray', '4')
    // Add one dot in the legend for each name.

    svg
      .selectAll('myLable')
      .data(dataReady.data)
      .enter()
      .append('text')
      .attr('x', width - 100)
      .attr('y', function (d) {
        console.log('reading', d)
        return y(d.threshold.max)
      })
      .style('font-size', '12px')
      .style('font-weight', 'bold')
      .attr('transform', 'translate(-10, -5)')
      .text(function (d) {
        return d.reading + ' max'
      })
      .attr('fill', 'black')

    svg
      .selectAll('myLines')
      .data(dataReady.data)
      .enter()
      .append('line')
      .attr('x1', 0)
      .attr('y1', function (d) {
        console.log('reading', d)
        return y(d.threshold.max)
      })
      .attr('x2', width)
      .attr('y2', function (d) {
        console.log('reading', d)
        return y(d.threshold.max)
      })
      .attr('stroke', 'black')
      .attr('stroke-width', 1)
      .attr('stroke-dasharray', '4')
    // Add one dot in the legend for each name.
    svg
      .selectAll('mydots')
      .data(allLines)
      .enter()
      .append('rect')
      .attr('width', 8)
      .attr('height', 8)
      .attr('x', 10)
      .attr('y', function (d, i) {
        return height - 20 - i * 12
      }) // 100 is where the first dot appears. 25 is the distance between dots
      .attr('r', 7)
      .style('fill', function (d) {
        return myColor(d)
      })
      .style('font-size', '12px')
    // Add one dot in the legend for each name.
    svg
      .selectAll('mylabels')
      .data(allLines)
      .enter()
      .append('text')
      .attr('x', 25)
      .attr('y', function (d, i) {
        return height - 15 - i * 12
      }) // 100 is where the first dot appears. 25 is the distance between dots
      .style('fill', function (d) {
        return myColor(d)
      })
      .text(function (d) {
        return d
      })
      .attr('text-anchor', 'left')
      .style('alignment-baseline', 'middle')
      .style('font-size', '12px')
  }

  return (
    <Row
      style={{
        display: 'flex',
        width: 'fit-content',
        position: 'relative',
        justifyContent: 'space-between',
        flexDirection: 'row',
      }}
    >
      <Col style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <label>
          {props.data.devicename == 'Watch' ? 'Steps' : props.data.devicename}
        </label>
      </Col>

      <Col
        className={props.isrotate ? 'mobile-measurementgraph' : ''}
        style={{
          display: 'flex',
          position: 'relative',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
          {' '}
          <CaretLeftOutlined style={{ fontSize: '32px' }} onClick={back} />
        </div>

        <div id={props.identifier}></div>
        <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
          <CaretRightOutlined style={{ fontSize: '32px' }} onClick={next} />
        </div>
      </Col>
    </Row>
  )
}

export default Graph
